import { BridgeFiatRail } from 'services/merchants/types';

import ACHBankAccountForm from '../../createAccount/components/forms/ach';
import BrebBankAccountForm from '../../createAccount/components/forms/breb';
import PixBankAccountForm from '../../createAccount/components/forms/pix';
import SepaBankAccountForm from '../../createAccount/components/forms/sepa';
import SpeiBankAccountForm from '../../createAccount/components/forms/spei';
import SwiftBankAccountForm from '../../createAccount/components/forms/swift';
import { usePayout } from '../context';
import { PayoutType } from '../types';

const PayoutBankDetails = () => {
  const payout = usePayout();

  if (!payout[PayoutType.Fiat].paymentRail) {
    throw new Error('Payment rail is not available for bank details form');
  }

  const bankAccountForm = {
    [BridgeFiatRail.ACH]: <ACHBankAccountForm paymentRail={BridgeFiatRail.ACH} />,
    [BridgeFiatRail.ACH_SAME_DATE]: <ACHBankAccountForm paymentRail={BridgeFiatRail.ACH_SAME_DATE} />,
    [BridgeFiatRail.WIRE]: <ACHBankAccountForm paymentRail={BridgeFiatRail.WIRE} />,
    [BridgeFiatRail.SWIFT]: <SwiftBankAccountForm />,
    [BridgeFiatRail.SEPA]: <SepaBankAccountForm />,
    [BridgeFiatRail.SPEI]: <SpeiBankAccountForm />,
    [BridgeFiatRail.PIX]: <PixBankAccountForm />,
    [BridgeFiatRail.BRE_B]: <BrebBankAccountForm />,
  }[payout[PayoutType.Fiat].paymentRail!];

  return bankAccountForm;
};

export default PayoutBankDetails;
